// extracted by mini-css-extract-plugin
module.exports = {"echartsLazySuspenseContainer":"index_echartsLazySuspenseContainer__2tvBo","loadingContainer":"index_loadingContainer__3wsws"};